@if (isLoading()) {
	<mat-progress-bar mode="indeterminate" aria-label="Ładowanie"></mat-progress-bar>
} @else {
	@let timelineSegments = segments();
	@if (timelineSegments.length === 0) {
		<div class="alert alert-info my-0 fw-bold text-center">Brak zakresów w wybranym okresie</div>
	} @else {
		<div class="timeline-wrapper position-relative w-100" role="img" aria-label="Timeline zakresów kosztów">
			<div class="w-100 d-flex flex-row align-items-stretch overflow-hidden rounded-pill timeline-bars-track">
				@for (segment of timelineSegments; track $index) {
					@if (segment.price) {
						<div
							class="timeline-bar flex-shrink-0 d-flex align-items-center justify-content-center px-1"
							[ngClass]="segment.barClass"
							[class.timeline-bar-round-right]="!timelineSegments[$index + 1]?.price"
							[class.timeline-bar-round-left]="!timelineSegments[$index - 1]?.price"
							[style.width.%]="segment.widthPercent"
							[style.background-color]="segment.barClass ? null : segment.color"
						>
							<span
								class="timeline-bar-label text-truncate d-flex flex-column justify-content-center text-center"
								[matTooltip]="
									'Cena: ' +
									(segment.price.price | number: '1.2-2' : 'pl') +
									' | ' +
									(segment.price.dateRange.lower | date: 'dd.MM.yyyy') +
									' - ' +
									(segment.price.dateRange.upper | date: 'dd.MM.yyyy')
								"
							>
								<div class="fw-bold">Cena: {{ segment.price.price | number: '1.2-2' : 'pl' }}</div>
								<div>
									{{ segment.price.dateRange.lower | date: 'dd.MM.yyyy' }} -
									{{ segment.price.dateRange.upper | date: 'dd.MM.yyyy' }}
								</div>
							</span>
						</div>
					} @else {
						<div
							class="timeline-bar timeline-bar-unassigned flex-shrink-0"
							[style.width.%]="segment.widthPercent"
						></div>
					}
				}
			</div>
			@if (showDayScale()) {
				<div class="timeline-day-scale w-100 d-flex flex-row overflow-hidden mt-1">
					@for (dayInfo of dayScaleWithMonth(); track $index) {
						<div class="timeline-day-cell text-center" [style.width.%]="dayScaleWidthPercent()">
							{{ dayInfo.dayOfMonth }}
						</div>
					}
				</div>
			}
			@if (!showDayScale()) {
				<div class="timeline-month-markers w-100 position-relative mt-1">
					@for (pos of monthBoundaryPositions(); track $index) {
						<div class="timeline-month-tick position-absolute" [style.left.%]="pos"></div>
					}
				</div>
			}
			<div class="timeline-month-scale w-100 d-flex flex-row overflow-hidden mt-1">
				@for (month of monthSegments(); track month.label + $index) {
					<div class="timeline-month-cell text-center" [style.width.%]="month.widthPercent">
						{{ month.label }}
					</div>
				}
			</div>
		</div>
	}
}
